import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PortfolioLoadingService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public readonly isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  setLoading(value: boolean): void {
    this.isLoadingSubject.next(value);
  }

  getLoading(): boolean {
    return this.isLoadingSubject.value;
  }
}
